<mlp-ng-password
    [inputId]="inputId"
    [inputName]="inputName"
    [inputStyle]="inputStyle"
    [inputDisabled]="inputDisabled"
    [placeholder]="placeholder"
    [icon]="icon"
    [loading]="loading"
    [input]="input"
    [errors]="errors"
    (blur)="blur.emit()"
    (focus)="focus.emit()"
    [(ngModel)]="value"
></mlp-ng-password>

<div class="d-flex justify-items-center mt-1 password-strength" *ngIf="value || showStrengthBar">
    <mlp-ng-progress-bar
        class="w-100 mr-2 mt-2"
        [progress]="strength"
        [barStyle]="
            articulate(strength, [
                'danger',
                'warn',
                'secondary'
            ])
        "
    ></mlp-ng-progress-bar>

    <div class="d-flex text-uppercase password-strength__label">
        {{ articulate(strength, ["weak", "medium", "strong"]) }}
        <mlp-ng-icon
            class="ml-2"
            name="custom-question-circle"
            placement="left"
            ngbPopover="Password should contain at least 8 characters, at least one lower case and upper case letter, a digit and special character."
        ></mlp-ng-icon>
    </div>
</div>
